// src/components/layout/Header.tsx

import { TabBar, type TabKey } from './TabBar';

interface HeaderProps {
  active: TabKey;
  onChange: (key: TabKey) => void;
}

export function Header({ active, onChange }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 bg-slate-950/80 backdrop-blur border-b border-slate-800">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <h1 className="text-lg font-bold text-primary-400 shrink-0">
          RocoBattle
        </h1>
        <TabBar active={active} onChange={onChange} />
      </div>
    </header>
  );
}